import styled from "styled-components/native";
import { light_black, spacing_s, white } from "../../StyleHelpers";

export const StyledContainer = styled.View`
	background-color: ${light_black};
	height: 100%;
`;

export const StyledMain = styled.View`
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	margin: 0 14.1% 70px 14.1%;
	border-radius: 16px;
	top: 15vh;
	overflow: hidden;
`;

export const StyledButtonContainer = styled.View`
	flex-direction: column;
	width: 71.8%;
	position: absolute;
	bottom: 15%;
	gap: 10px;
	margin: 0 14.1% 0 14.1%;
`;

export const StyledRowButtonContainer = styled.View`
	flex-direction: row;
`;

export const StyledText = styled.View<{ isNarrow?: boolean }>`
	align-self: stretch;
	color: ${white};
	text-align: ${({ isNarrow }) => (isNarrow ? "left" : "center")};
	font-size: 1.3125rem;
	font-style: normal;
	font-weight: 400;
	line-height: 1.4375rem;
`;

/*Narrow Style*/
export const StyledNarrowTextContainer = styled.View`
	position: absolute;
	display: flex;
	width: 100rem;
	padding-left: 2.5rem;
	align-items: left;
`;

export const StyledNarrowText = styled.View`
	display: flex;
	width: 81rem;
	height: 5rem;
	align-items: center;
	justify-content: center;
	gap: 1.5rem;
	flex-shrink: 0;
	padding: 0 5.5rem;
`;

export const StyledNarrowButtonContainer = styled.View`
	display: flex;
	width: 31.25rem;
	flex-direction: column;
	gap: ${spacing_s};
`;

export const StyledNarrowButtons = styled.View`
	display: flex;
	flex-direction: column;
	gap: ${spacing_s};
	align-self: stretch;
`;

export const StyledNarrowLogo = styled.View`
	align-items: center;
`;
